import lottie from 'lottie-web';

import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export class EventOptionAnimation {
    lottieContainer;

    constructor() {
        this.lottieContainer = document.querySelectorAll('.event-option__animation');
    }

    init() {
        if(this.lottieContainer) {
            for (let i = 0; i < this.lottieContainer.length; i++) {

                const url = this.lottieContainer[i].dataset.url;
                const trigger = this.lottieContainer[i].querySelector('.e-lottie__svg');

                lottie.loadAnimation({
                    name: `animation${[i]}`,
                    container: trigger,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    path: url
                });

                ScrollTrigger.create({
                    trigger: trigger,
                    start: "top center",
                    end: "center top",
                    onEnter: () => lottie.play(`animation${[i]}`),
                    onLeave: () => lottie.goToAndStop(0,0,`animation${[i]}`),
                    onEnterBack: () => lottie.play(`animation${[i]}`)
                });
            }
        }
    }
}